<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import { bgSecondary, textPrimary } from '@nora-monorepo/ui-shared';

import { useConversationMessageStore } from '#nora-chat-ui/stores/conversation/message/conversation-message-store';

const { t } = useI18n();
const conversationMessageStore = useConversationMessageStore();
const { editingMessage } = storeToRefs(conversationMessageStore);

function cancel() {
  editingMessage.value = undefined;
}
</script>

<template>
  <div
    class="flex justify-between p-3"
    :class="[bgSecondary, textPrimary]"
  >
    <span class="font-semibold">{{ t('message.editingMessage') }}</span>
    <a
      class="my-auto cursor-pointer"
      @click.prevent.stop="cancel"
    >
      <span class="mi close" />
    </a>
  </div>
</template>
